<ng-container *ngIf="job.state !== DistributionJobState.SENT">
    <div class="row no-gutters">
        <div class="col-sm-12 col-md-6">
            <div class="row no-gutters mb-4">
                <div class="col-10">
                    <dr-checkbox [idPrefix]="idPrefix"
                                 [idSuffix]="'insign_send_now'"
                                 [boolValue]="job.insign_send_now"
                                 (updated)="setSignNowOption($event.value)"
                                 [label]="job.trans.insign_send_now | translate"
                                 [invalid]="noToSelectionError"
                                 [disabled]="disabled || job.state !== DistributionJobState.INITIAL">
                    </dr-checkbox>
                </div>

                <div class="col-2"></div>
            </div>
        </div>
    </div>

    <div class="row no-gutters">

        <div class="col-sm-12 col-md-6">
            <div class="row no-gutters mb-4">
                <div class="col-10">
                    <dr-checkbox [idPrefix]="idPrefix"
                                 [idSuffix]="'insign_send_email'"
                                 [boolValue]="job.insign_send_email"
                                 [label]="job.trans.insign_send_email | translate"
                                 (updated)="setEmailOption($event.value)"
                                 [invalid]="noToSelectionError"
                                 [disabled]="disabled || job.state !== DistributionJobState.INITIAL || job.insign_send_now">
                    </dr-checkbox>
                </div>

                <div class="col-2"></div>
            </div>

            <div class="row no-gutters">
                <div class="col-10">
                    <mat-form-field class="full-width readonly"
                                    [ngClass]="{ 'has-error': emailToError }">
                        <mat-label>{{ job.trans.insign_email_to | translate }}</mat-label>
                        <input id="{{idPrefix}}insign_email_to"
                               type="text" matInput
                               [value]="job.insign_email_to || ' '"
                               [readonly]="true"
                               [disabled]="disabled || !job.insign_send_email || job.insign_send_now"
                               [required]="isCaseDistributionJob">
                    </mat-form-field>
                </div>

                <div class="col-2" align="center">
                    <button *ngIf="job.state === DistributionJobState.INITIAL"
                            id="{{idPrefix}}btn.edit_email"
                            class="edit-btn"
                            mat-icon-button
                            color="primary"
                            (click)="editEmailDistribution()"
                            [disabled]="disabled || !job.insign_send_email || job.insign_send_now">
                        <mat-icon [ngClass]="{ 'iq-color-warn-light': emailToError }">create</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="col-sm-12 col-md-6">
            <div class="row no-gutters mb-4">
                <div class="col-10">
                    <dr-checkbox [idPrefix]="idPrefix"
                                 [idSuffix]="'insign_send_sms'"
                                 [boolValue]="job.insign_send_sms"
                                 [label]="job.trans.insign_send_sms"
                                 (updated)="setSMSOption($event.value)"
                                 [invalid]="noToSelectionError"
                                 [disabled]="disabled || job.state !== DistributionJobState.INITIAL || job.insign_send_now">
                    </dr-checkbox>
                </div>

                <div class="col-2"></div>
            </div>

            <div class="row no-gutters">
                <div class="col-10">
                    <mat-form-field class="full-width readonly"
                                    [ngClass]="{ 'has-error': smsToError }">
                        <mat-label>{{ job.trans.insign_sms_to | translate }}</mat-label>
                        <input id="{{idPrefix}}insign_sms_to"
                               type="text" matInput
                               [value]="job.insign_sms_to || ' '"
                               [readonly]="true"
                               [disabled]="disabled || !job.insign_send_sms || job.insign_send_now"
                               [required]="isCaseDistributionJob">
                    </mat-form-field>
                </div>

                <div class="col-2" align="center">
                    <button *ngIf="job.state === DistributionJobState.INITIAL"
                            id="{{idPrefix}}btn.edit_sms"
                            class="edit-btn"
                            mat-icon-button
                            color="primary"
                            (click)="editSMSDistribution()"
                            [disabled]="disabled || !job.insign_send_sms || job.insign_send_now">
                        <mat-icon [ngClass]="{ 'iq-color-warn-light': smsToError }">create</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row no-gutters mb-4 pl-1">
        <validity-period [idPrefix]="(idPrefix + 'insign_session_valid_for_hours')"
                         [label]="(job.trans.insign_session_valid_for_hours  | translate) + (isCaseDistributionJob ? ' *' : '')"
                         [invalid]="periodError"
                         [disabled]="disabled || job.state !== DistributionJobState.INITIAL || job.insign_send_now"
                         [selectedPeriod]="job.insign_session_valid_for_hours"
                         (selectedPeriodChange)="onPeriodChange($event)">
        </validity-period>
    </div>

</ng-container>

<ng-container *ngIf="job.state === DistributionJobState.SENT">

    <div class="p-4">
        <div class="row">
            <div class="col-sm-4 col-lg-2" *ngIf="job.insign_send_email">
                <strong>{{ job.trans.insign_email_to | translate }}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.insign_email_to }}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-lg-2" *ngIf="job.insign_send_sms">
                <strong>{{ job.trans.insign_sms_to | translate }}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.insign_sms_to }}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-lg-2">
                <strong>{{ job.trans.insign_state | translate }}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.getTooltip() | translate }}</span>
            </div>
        </div>

        <div class="row" *ngIf="job.insign_state === InsignState.SIGNING">
            <div class="col-sm-4 col-lg-2">
                <strong>{{ job.trans.insign_session_valid_for_hours | translate }}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.insign_session_valid_until | drDateTime }}</span>
            </div>
        </div>
    </div>

</ng-container>
